export const getSentRequests = ({ requests: { sentRequests } }) => sentRequests
export const getReceivedRequests = ({ requests: { receivedRequests } }) =>
	receivedRequests
